module.exports = __webpack_public_path__ + "fonts/d04b1617f52d589408001e920ac21557.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/scenes/TripDetails/components/RegionSelect/img/icon_channel_selected.svg
// module id = 1526
// module chunks = 0